import { EInvoiceInfoPage } from './../e-invoice-info/e-invoice-info.page';
import { EInvoiceInfoPageRoutingModule } from './e-vinoice-validate-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { EInvoiceValidatorComponent } from './e-invoice-validator.component';
import { EInvoiceValidatorComponentRoutingModule } from './e-invoice-validate-routing.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, EInvoiceValidatorComponentRoutingModule],
  declarations: [EInvoiceValidatorComponent, EInvoiceInfoPage],
})
export class EInvoiceValidatorComponentModule {}
